import { createImmutableMap } from 'ctm-util-functions';

/**
 * The auth reducer to handle auth tokens.
 * @param {Object} initialState - The initial state of the quote.results object.
 * @returns {JSON} New state
 */
const createTokensReducer = (initialState = {}) => {
    const immutableInitialState = createImmutableMap(initialState);
    return (state = immutableInitialState, action) => {
        switch (action.type) {
            case 'SET_AUTH_TOKENS': {
                if (action.access_token && action.refresh_token) {
                    return state.merge({
                        access_token: action.access_token,
                        refresh_token: action.refresh_token
                    });
                }
                if (action.access_token) {
                    return state.set('access_token', action.access_token);
                }
                if (action.refresh_token) {
                    return state.set('refresh_token', action.refresh_token);
                }
                return state;
            }
            case 'REMOVE_AUTH_TOKEN': {
                if (action.name) {
                    return state.delete(action.name);
                }
                return state;
            }

            default: {
                return state;
            }
        }
    };
};

export { createTokensReducer };
